import { Box } from "@mui/material";
import StackedBidsChart from "./StackedBidsChart";
import { BusinessType } from "./types";

const EcpFcrVisualization = ({ businessType, deliveryDate }: { businessType: BusinessType; deliveryDate: Date }) => {
  return (
    <Box height={"calc(100vh - 125px)"}>
      <StackedBidsChart deliveryDate={deliveryDate} businessType={businessType} height={"100%"} />
    </Box>
  );
};
export default EcpFcrVisualization;
